import { SegmentedFilter } from '@/shared/components/SegmentedFilter'
import { FIXABLE_FILTERS, FIXABLE_FILTER_COLOR, SEVERITY_FILTERS, SEVERITY_FILTER_COLOR, filterCounts, type FixableFilter, type SeverityFilter } from '@/features/providers/lib/findingFilters'

/** The severity / fixable filter segmented controls for the Vulnerabilities panel. Each segment
 *  carries its cross-filtered bucket count (see filterCounts) and is disabled when that count is
 *  0, so the two groups can never disagree about what is on screen. */
export function FindingFilters({ severity, setSeverity, fixable, setFixable, counts }: {
  severity: SeverityFilter
  setSeverity: (s: SeverityFilter) => void
  fixable: FixableFilter
  setFixable: (f: FixableFilter) => void
  counts: ReturnType<typeof filterCounts>
}) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 14 }}>
      <SegmentedFilter
        label="Filter by severity"
        value={severity}
        onChange={setSeverity}
        options={SEVERITY_FILTERS.map((s) => ({
          key: s, count: counts.severity[s], color: SEVERITY_FILTER_COLOR[s],
          label: s === 'all' ? 'All' : s[0].toUpperCase() + s.slice(1),
        }))}
      />
      <SegmentedFilter
        label="Filter by fixable"
        value={fixable}
        onChange={setFixable}
        options={FIXABLE_FILTERS.map((f) => ({
          key: f, count: counts.fixable[f], color: FIXABLE_FILTER_COLOR[f],
          label: f === 'all' ? 'All' : f === 'fixable' ? 'Fixable' : 'Non-fixable',
        }))}
      />
    </div>
  )
}
